module.exports = __webpack_public_path__ + "static/trainingbanner-5c29a29ca408c655b04d9dd657b86118.jpg";